// Module
var code = `<template>
  <mdc-icon if.bind="params.value == 3" aria-hidden="true" style="color:#684e4a">remove</mdc-icon>
  <mdc-icon if.bind="params.value == 2" aria-hidden="true" class="warning">check</mdc-icon>
  <a href.bind="url">
    <mdc-icon if.bind="params.value == 1" aria-hidden="true" class="mdc-theme--primary">check</mdc-icon>
  </a>
</template>
`;
// Exports
export default code;